import { useEffect } from 'react'
import { FaPlug, FaRobot, FaBell, FaChartBar } from 'react-icons/fa6'
import { SubtitleTemplate } from '../../../components/template/subtitle'
import { ParagrafTemplate } from '../../../components/template/paragraf'

const reasons = [
  {
    icon: FaPlug,
    title: 'Integrasi Langsung Mikrotik',
    desc: 'Terhubung otomatis dengan router Mikrotik untuk manajemen PPPoE dan Hotspot tanpa konfigurasi rumit.',
  },
  {
    icon: FaRobot,
    title: 'Auto Isolir & Aktifasi',
    desc: 'Pelanggan yang menunggak otomatis diisolir, dan langsung aktif saat pembayaran dikonfirmasi.',
  },
  {
    icon: FaBell,
    title: 'Notifikasi Otomatis',
    desc: 'Kirim pengingat tagihan via WhatsApp dan SMS secara otomatis sebelum jatuh tempo.',
  },
  {
    icon: FaChartBar,
    title: 'Dashboard Real-time',
    desc: 'Pantau revenue, status pelanggan, dan performa jaringan dari satu layar dashboard.',
  },
]

const quickStats = [
  { num: '4+', label: 'Tahun Pengalaman' },
  { num: '500+', label: 'ISP Terdaftar' },
  { num: '50K+', label: 'Pelanggan Dikelola' },
  { num: '34', label: 'Provinsi Terjangkau' },
]

export default function LpAboutSection() {
  useEffect(() => {
    const elements = document.querySelectorAll(
      '.reveal, .reveal-left, .reveal-right, .reveal-scale'
    )

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active')
          }
        })
      },
      { threshold: 0.3 }
    )

    elements.forEach((el) => observer.observe(el))

    return () => observer.disconnect()
  }, [])
  return (
    <section
      id="tentang"
      className="relative py-24 lg:py-32 grid-bg w-full overflow-hidden"
      aria-labelledby="tentang-heading"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Kiri */}
          <div className="reveal-left">
            <SubtitleTemplate className="text-ocean-600 font-semibold tracking-wider uppercase mb-4 block text-start">
              Tentang Kami
            </SubtitleTemplate>
            <h2
              id="tentang-heading"
              className="font-display text-2xl sm:text-3xl md:text-4xl  font-bold leading-tight mb-6"
            >
              Solusi Billing yang Dibangun{' '}
              <span className="gradient-text">Khusus untuk ISP</span>
            </h2>
            <p className="text-slate-custom leading-relaxed mb-6">
              Radius Trend hadir dari pemahaman mendalam tentang tantangan nyata
              yang dihadapi penyedia internet di Indonesia. Kami tahu bahwa
              mengelola pelanggan, menagih secara tepat waktu, dan memastikan
              jaringan berjalan stabil bukanlah hal mudah.
            </p>
            <p className="text-slate-custom leading-relaxed mb-8">
              Dibangun sejak 2020, platform kami telah mengalami evolusi
              berdasarkan masukan langsung dari ratusan operator ISP dan RT/RW
              Net di seluruh Indonesia. Setiap fitur dirancang untuk menyelesaikan
              masalah nyata, bukan sekadar tambahan fitur yang tidak berguna.
            </p>
            <div className="grid grid-cols-2 gap-6">
              {quickStats.map((item, i) => (
                <div
                  key={i}
                  className="p-4 rounded-xl bg-navy-700/30 border border-navy-500/20"
                >
                  <div className="font-display text-2xl font-bold text-ocean-500">
                    {item.num}
                  </div>
                  <div className="text-sm text-slate-custom mt-1">
                    {item.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Kanan */}
          <div className="reveal-right relative w-full">
            <div
              className="absolute -inset-4 bg-ocean-800/10 blur-3xl rounded-3xl"
              aria-hidden="true"
            />
            <div className="relative bg-navy-800 rounded-2xl border border-navy-500/30 p-8">
              <SubtitleTemplate className="text-ocean-600 font-bold mb-6">
                Kenapa ISP Memilih Radius Trend?
              </SubtitleTemplate>
              <div className="space-y-5">
                {reasons.map((item, i) => {
                  const Icon = item.icon
                  return (
                    <div key={i} className="flex gap-4">
                      <div className="w-10 h-10 rounded-xl bg-ocean-800/15 border border-ocean-700/20 flex items-center justify-center flex-shrink-0">
                        <Icon className="text-ocean-500 text-sm" />
                      </div>
                      <div>
                        <SubtitleTemplate className="font-semibold text-white text-sm mb-1">
                          {item.title}
                        </SubtitleTemplate>
                        <ParagrafTemplate className=" leading-relaxed">
                          {item.desc}
                        </ParagrafTemplate>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}